module.exports = __webpack_public_path__ + "images/3b39b023962915e3a1b80064412789d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/sara_thumb.jpg
// module id = 140
// module chunks = 24